// Renders a static dashboard card header in the same style as the
// non-static visualisation cards: title on the left, category pill on the right.
//
// AI-CONTEXT: See docs/patterns.md#dashboard-static-card

/**
 * @param {object} props
 * @param {string} props.title - Header shown at the left of the card
 * @param {{ variant: string, label: string }} [props.pill] - Optional category pill rendered at the right
 */
const StaticCardLabel = ({ title, pill }) => {
    return (
        <p className='new-dashboard-card-label'>
            <span>
                {title}
            </span>
            {pill && (
                <span className={`new-dashboard-card-label-type new-dashboard-card-label-type-${pill.variant}`}>
                    {pill.label}
                </span>
            )}
        </p>
    )
}

export default StaticCardLabel
